/**
 * 비회원 가격 마스킹 (기획확정안 §4.2).
 *
 * 공개: 카드명·이미지·언어판·세트·카드번호·레어도 — 카드 식별 능력은 충분히 경험시킨다.
 * 가격: **"약 12만원대" 수준으로만** 표시.
 * 마스킹: 정확한 대표 시세 · 최근 거래 · 거래량 · 가격 그래프 · 등급별 가격 ·
 *        다른 언어판 비교 · 시세 신뢰도 → 로그인 버튼 제공.
 *
 * ⚠ 문구는 i18n(common:mask.*) — "만원대" 라는 단위 자체가 ko/ja 에만 있어서
 *   영어는 원 금액을 그대로 쓴다. React 밖이라 i18n 인스턴스를 직접 부른다.
 */
import i18n from "../i18n";

/**
 * 정확한 금액을 "약 N만원대" 수준으로 뭉갠다.
 *
 * 문서의 예시가 "약 12만원대"이므로 만 단위 아래를 버리고 만원대로 표기한다.
 * - 120,000~129,999 → "약 12만원대"
 * - 4,500          → "약 1만원 미만"  (만원 미만은 구간이 만들어지지 않는다)
 * - 1,240,000      → "약 124만원대"
 */
export function maskPrice(amount: number): string {
  if (!Number.isFinite(amount) || amount < 0) return "-";
  const man = Math.floor(amount / 10_000);
  if (man < 1) return i18n.t("mask.priceUnder");
  // 만 단위는 한국어·일본어에만 있다 — 영어 문구는 amount(=반올림된 원 금액)를 쓴다.
  return i18n.t("mask.priceBand", {
    man: man.toLocaleString("ko-KR"),
    amount: (man * 10_000).toLocaleString("en-US"),
  });
}

/** §4.2 마스킹 대상 항목 — 비회원에게는 값 대신 로그인 유도를 보여준다. */
export type MaskedField =
  | "exactPrice"
  | "recentTrades"
  | "tradeVolume"
  | "priceChart"
  | "gradePrices"
  | "languageCompare"
  | "reliability";

/**
 * 비회원이면 마스킹 대상인지 판정.
 * 회원(isAuthenticated=true)은 전부 공개 — §4 표.
 */
export function isMasked(isAuthenticated: boolean, _field: MaskedField): boolean {
  return !isAuthenticated;
}
